import { useState } from 'react';
import TfgDeadlineBanner from '@/features/dashboard/tfg/components/TfgDeadlineBanner.tsx';
import GenerateDeklaracjaDialog from '@/features/dashboard/tfg/components/GenerateDeklaracjaDialog.tsx';
import DeklaracjaPreviewModal from '@/features/dashboard/tfg/components/DeklaracjaPreviewModal.tsx';
import { TfgDeklaracjaPreviewDto } from '@/features/dashboard/tfg/types/TfgDeklaracjaPreviewDto.ts';
import { PageTitle } from '@/components/ui/Title.tsx';

const TfgPage = () => {
  const [isGenerateOpen, setIsGenerateOpen] = useState(false);
  const [preview, setPreview] = useState<TfgDeklaracjaPreviewDto | null>(null);

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <PageTitle>Turystyczny Fundusz Gwarancyjny</PageTitle>
      </div>

      <TfgDeadlineBanner onGenerate={() => setIsGenerateOpen(true)} />

      {isGenerateOpen && (
        <GenerateDeklaracjaDialog
          onClose={() => setIsGenerateOpen(false)}
          onSuccess={(data) => {
            setIsGenerateOpen(false);
            setPreview(data);
          }}
        />
      )}

      {preview && (
        <DeklaracjaPreviewModal
          data={preview}
          onClose={() => setPreview(null)}
        />
      )}
    </div>
  );
};

export default TfgPage;
